import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import CarouselClaro from '../carousel/CarouselClaro';
import { converter } from '../../helpers/converter';
import * as actionsCarousel from '../../action-creators/carousel';
import HTMLDECODE from '../../utils/htmlDecode';
import { GetRegion, CAROUSEL } from '../../constants';
import Utils from '../../utils/Utils';
import PosterTitle from '../posters/PosterTitle';
import NavigationWrapper from '../NavigationWrapper';

const IMAGE_MEDIUM = 'image_medium';
const IMAGE_LARGE = 'image_large';
const SMALL_LARGE = 'image_small';
const EXT_EVENT_IMAGE_NAME = 'ext_eventimage_name';

export class ContentList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      groups: null,
      _id: Utils.createId(),
      width: 0,
      height: 0,
    };
    this.isEmpty = true;
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    if (!this.props.blockFetch) {
      this.fetchContentList();
    }
    this.__mounted = true;

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    this.__mounted = false;
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.state.width = window.innerWidth;
    this.state.height = window.innerHeight;
    this.forceUpdate();
  }

  redirectClick(e, redirectLink) {
    if (redirectLink.action) {
      e.preventDefault();
      e.stopPropagation();
      if (redirectLink.action.type === 'open') {
        return window.open(redirectLink.action.source);
      }
    }
  }

  fetchContentList() {
    if (!this.props.url) {
      return;
    }
    const params = {};
    if (this.props.recommended && this.props.seen) {
      this.favoritedOffset = this.props.seen[this.props.carrouselData.offset];
      /*   if (!this.favoritedOffset || this.favoritedOffset.groups.length != 0) {
        const defaultIndex = Utils.generateRandom(0, this.props.carousel.favorites.length);
        this.favoritedOffset = this.props.carousel.favorites[defaultIndex];
      } else {
        return this.hideIt = true;
      }
*/
      if (!this.favoritedOffset) {
        return;
      }

      params.group_id =
        this.favoritedOffset.group_id || this.favoritedOffset.id;
      this.templateTitle = converter.convertApaUnicode(
        this.props.translations,
        'home_user_recome2many_title',
        'Porque viste  ',
      );

      this.title = this.templateTitle.replace(
        '{TITLE}',
        this.favoritedOffset.title,
      );
    }

    const options = {
      _id: this.state._id,
      url: this.props.url,
      config: this.props.config,
      isMyList: this.props.isMyList,
      isSeenList: this.props.isSeenList,
      params,
    };

    options.isRecordingsCarousel =
      this.props.nameCarousel === CAROUSEL.MIS_PROGRAMAS_GRABADOS ||
      this.props.nameCarousel === CAROUSEL.POR_GRABAR;

    return this.props.fetchContentList(options);
  }

  showFavorite() {
    if (this.props.showFavorite && this.favoritedOffset) {
      const userType = Utils.userStatusParse(this.props.user);
      const urlPlayer =
        typeof this.props.config === 'object'
          ? this.props.config.urlPlayer
          : undefined;
      let redirectLink = `/${GetRegion()}/vcard/homeuser/${
        this.favoritedOffset.title_uri
      }/${this.favoritedOffset.id}`;

      if (
        this.favoritedOffset.id ||
        this.favoritedOffset.group_id ||
        this.favoritedOffset.type
      ) {
        redirectLink = Utils.buildRedirect({
          content: this.favoritedOffset,
          userType,
          urlPlayer,
        });
      }

      return (
        <div className="recommendation-favorite-image">
          <div className="item-wrapper">
            <Link
              to={redirectLink.redirectUrl}
              onClick={e => this.redirectClick(e, redirectLink)}
            >
              <img
                alt=""
                className="recommendation-image"
                src={this.favoritedOffset.image_medium}
              />
              <span className="play">
                <i className="fa fa-play-circle-o" />
              </span>
              {/* <PosterFormatType
              formatTypes={this.favoritedOffset.format_types}
              live_enabled={this.favoritedOffset.live_enabled}
              proveedor_name={this.favoritedOffset.proveedor_name}
            /> */}
              <PosterTitle resource={this.favoritedOffset} />
            </Link>
          </div>
        </div>
      );
    }

    return null;
  }

  getSize() {
    if (this.state.width < 768) {
      return IMAGE_MEDIUM;
    }
    if (this.props.recording) {
      return EXT_EVENT_IMAGE_NAME;
    }
    if (this.props.claroRecomendation) {
      return IMAGE_LARGE;
    }
    return SMALL_LARGE;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.recording_data !== this.props.recording_data) {
      this.fetchContentList();
    }
  }

  render() {
    let groups = [];
    if (this.props.carousel.findById[this.state._id]) {
      groups = this.props.carousel.findById[this.state._id].groups;
      if (groups.length > 0) {
        this.isEmpty = false;
        this.hideIt = false;
      } else {
        return null;
      }
    }
    const ownTitle = this.title || this.props.titleDefault;
    const carrosuleName = this.props.carrouselData
      ? this.props.carrouselData.name
      : '';
    let sectionClass =
      'section-0 section-sugeridos section-carrousel padding-bottom-2';
    let carrouselContainerClass = 'container2';
    let imagesSize = {};
    let classCarouselDinamico =
      'jcarousel jcarousel-1 horizontal carrousel-row';

    if (this.props.carrouselPlayAndGo) {
      this.isPlayAndGo = true;
      groups = this.props.carrouselPlayAndGo;

      classCarouselDinamico =
        'jcarousel jcarousel-1 horizontal carrousel-row blabla';
      imagesSize = {
        heigth: 165,
        width: 292,
      };
    }

    if (this.props.showFavorite) {
      imagesSize = {
        heigth: 200,
        width: 350,
      };
    }

    if (this.props.claroRecomendation) {
      sectionClass = 'section-carrousel section-recommended horizontal';
    }
    if (this.props.recording) {
      sectionClass = 'section-carrousel horizontal';
    }

    if (this.props.showFavorite) {
      if (!this.favoritedOffset) {
        return null;
      }
      carrouselContainerClass = `${carrouselContainerClass} recommendation-image-carrousel`;
    }

    if (this.props.isMyList) {
      if (this.props.carousel.favorites.length === 0) {
        return null;
      }
      carrouselContainerClass = `${carrouselContainerClass} favorites-carousel`;
      groups = this.props.carousel.favorites;
    }

    if (this.props.isSeenList) {
      if (this.props.carousel.seenList.length === 0) {
        return null;
      }
      groups = this.props.carousel.seenList;
    }
    if (
      this.props.nameCarousel == CAROUSEL.MIS_PROGRAMAS_GRABADOS ||
      this.props.nameCarousel == CAROUSEL.POR_GRABAR
    ) {
      const show = groups.length > 0;
      return (
        <section className={sectionClass}>
          {show && (
            <div>
              <div className="container2">
                <div className="pull-left">
                  <h4
                    dangerouslySetInnerHTML={{
                      __html: HTMLDECODE(ownTitle),
                    }}
                  />
                </div>
              </div>
              <div className={carrouselContainerClass}>
                <div className={classCarouselDinamico}>
                  <NavigationWrapper>
                    <CarouselClaro
                      groups={groups}
                      size={this.getSize()}
                      sizeAlt={this.getSize()}
                      claroRecommendation={this.props.claroRecomendation}
                      isMyList={this.props.isMyList}
                      isBuyList={this.props.isBuyList}
                      imagesSize={imagesSize}
                      name={HTMLDECODE(carrosuleName)}
                      title={HTMLDECODE(ownTitle)}
                      isPlayAndGo={this.isPlayAndGo}
                      isRecording={this.props.recording}
                      progressBar={this.props.progressBar}
                    />
                  </NavigationWrapper>
                </div>
              </div>
            </div>
          )}
        </section>
      );
    }

    return (
      <section className={sectionClass}>
        <div className="container2">
          <div className="pull-left">
            <h4
              dangerouslySetInnerHTML={{
                __html: HTMLDECODE(ownTitle),
              }}
            />
          </div>
        </div>

        {this.showFavorite.bind(this)()}

        <div className={carrouselContainerClass}>
          <div className={classCarouselDinamico}>
            <NavigationWrapper>
              <CarouselClaro
                groups={groups}
                size={this.getSize()}
                sizeAlt={this.getSize()}
                claroRecommendation={this.props.claroRecomendation}
                isMyList={this.props.isMyList}
                isSeenList={this.props.isSeenList}
                isBuyList={this.props.isBuyList}
                imagesSize={imagesSize}
                name={HTMLDECODE(carrosuleName)}
                title={HTMLDECODE(ownTitle)}
                isPlayAndGo={this.isPlayAndGo}
                isRecording={this.props.recording}
                progressBar={this.props.progressBar}
                type={this.props.carrouselData && this.props.carrouselData.type}
              />
            </NavigationWrapper>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  translations: state.translations,
  user: state.user,
  config: state.config,
  router: state.routing,
  carousel: state.carousel,
  seen: state.carousel.seen,
  recording_data: state.eventCard.recordings_data,
});

const mapDispatchToProps = dispatch => ({
  fetchContentList(options) {
    return dispatch(actionsCarousel.fetchContentList(options));
  },
});

ContentList.propTypes = {
  showFavorite: PropTypes.bool,
  user: PropTypes.shape({}),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentList);
